import { OrderItem } from '../types';

export const matchesInput = (item: OrderItem, input: string): boolean => {
    const needle = input.toLowerCase();
    const orderIdString = String(item.OrderID);
    return (
        item.Customer_Name.toLowerCase().includes(needle) ||
        orderIdString.toLowerCase().includes(needle)
    );
};

export const filterByInputAndStatus = (
    list: OrderItem[],
    input: string,
    statusId: number | null,
    isStatusFilterOn: boolean,
): OrderItem[] => {
    const baseFiltered = isStatusFilterOn && statusId !== null
        ? list.filter(e => e.Status === +statusId)
        : list;
    if (!input) return baseFiltered;
    return baseFiltered.filter(item => matchesInput(item, input));
};
